import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Kind, SelectionRow } from './selection';
export interface SelectionDialogProps {
  selected: SelectionRow | null;
  kind: Kind;
  enabled: boolean;
  rank: string;
  reason: string;
  conflict: boolean;
  saving: boolean;
  hasError: boolean;
  setEnabled(value: boolean): void;
  setRank(value: string): void;
  setReason(value: string): void;
  onClose(): void;
  onReload(): void;
  onSave(): void;
}
export function SelectionDialog({
  selected,
  kind,
  enabled,
  rank,
  reason,
  conflict,
  saving,
  hasError,
  setEnabled,
  setRank,
  setReason,
  onClose,
  onReload,
  onSave,
}: SelectionDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={!!selected}
      onClose={() => {
        if (!saving) onClose();
      }}
      fullWidth
    >
      <DialogTitle>{t('hotelCatalogAdmin.edit')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <Typography>{selected?.hotel_display_name ?? selected?.geo_place_name}</Typography>
          <FormControlLabel
            control={
              <Switch checked={enabled} disabled={conflict || saving} onChange={(_, checked) => setEnabled(checked)} />
            }
            label={t('hotelCatalogAdmin.enabled')}
          />
          {kind === 'hotel-memberships' && (
            <TextField
              label={t('hotelCatalogAdmin.rank')}
              type="number"
              value={rank}
              disabled={conflict || saving}
              onChange={(e) => setRank(e.target.value)}
              inputProps={{ min: 0, max: 2147483647, step: 1 }}
            />
          )}
          <TextField
            label={t('hotelCatalogAdmin.reason')}
            value={reason}
            disabled={conflict || saving}
            onChange={(e) => setReason(e.target.value)}
            inputProps={{ maxLength: 512 }}
          />
          {hasError && (
            <Alert severity="error">{t(conflict ? 'hotelCatalogAdmin.conflict' : 'hotelCatalogAdmin.saveError')}</Alert>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button disabled={saving} onClick={() => onClose()}>
          {t('hotelCatalogAdmin.close')}
        </Button>
        {conflict ? (
          <Button
            onClick={() => {
              onReload();
            }}
          >
            {t('hotelCatalogAdmin.reload')}
          </Button>
        ) : (
          <Button
            disabled={saving || !reason.trim() || !/^\d+$/.test(rank) || Number(rank) > 2147483647}
            onClick={() => onSave()}
          >
            {t('hotelCatalogAdmin.save')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
